import { useUpdateConversationOfId } from 'hooks/business/conversationsHooks/useConversationOfId';
import {
  useCurrentQAPairKnowledgeQuery,
  useQAPairOpenedWithKeepAlive,
} from 'hooks/business/im/useQAPair';
import { persistSupplementKnowledgePopup } from 'services/api/supplementKnowledge';
import { isIdEqual } from 'utils/is';

export const useQAPairPersist = () => {
  const qaPairOpenedWithKeepAlive = useQAPairOpenedWithKeepAlive();
  const updateConversationOfId = useUpdateConversationOfId();
  const currentQAPairKnowledgeQuery = useCurrentQAPairKnowledgeQuery();

  return (conversationId: string) => {
    if (!qaPairOpenedWithKeepAlive || !currentQAPairKnowledgeQuery) {
      return;
    }

    if (!isIdEqual(conversationId, currentQAPairKnowledgeQuery.conversationId)) {
      return;
    }

    /**
     * 白名单用户，离开会话时调用接口标记会话
     * 从 lru 读取会话，避免异步更新状态导致获取数据异常
     */
    const queryMsgId = currentQAPairKnowledgeQuery.msgId;
    if (queryMsgId) {
      persistSupplementKnowledgePopup({
        conversationId,
        queryMsgId,
        timestampInMs: Date.now().toString(),
      }).then(() => {
        updateConversationOfId(
          {
            existKnowledgePopup: true,
          },
          conversationId,
        );
      });
    }
  };
};
